import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { TrendingUp } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/client/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Signed in with Google.");
        const redirect = sessionStorage.getItem("post_auth_redirect");
        sessionStorage.removeItem("post_auth_redirect");
        navigate(redirect || "/client/dashboard", { replace: true });
      } catch (e) {
        setError(formatApiError(e));
      }
    })();
  }, [location, navigate]);

  return (
    <div data-testid="auth-callback" className="flex min-h-screen flex-col items-center justify-center bg-[#FFFFFF] text-slate-900">
      <span className="flex h-11 w-11 items-center justify-center border border-[#6D28D9]/40 bg-[#6D28D9]/10">
        <TrendingUp className="h-5 w-5 text-[#6D28D9]" />
      </span>
      {error ? (
        <>
          <p data-testid="auth-callback-error" className="mt-6 max-w-sm text-center text-sm text-rose-600">{error}</p>
          <Link to="/client/login" className="mt-6 border border-[#6D28D9]/40 px-6 py-3 font-mono2 text-[11px] uppercase tracking-[0.2em] text-[#6D28D9]">
            Back to sign in
          </Link>
        </>
      ) : (
        <p className="mt-6 font-mono2 text-xs uppercase tracking-[0.3em] text-slate-500">Signing you in…</p>
      )}
    </div>
  );
}
